<script>

export default {
    name: "DrugSelectTemplate",

    data() {

        return {
            selectedItem: 0
        };
    },

    props: {
        items: {
            type: Array,
            default: function() {
                return [];
            }
        },
        showModal: Boolean
    },

    methods: {

        setItem(item) {
            this.selectedItem = item.itemID;
            this.$emit('itemSelected',item);
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-3/4 h-auto">
  <template v-slot:title>
    <h5 class="font-bold text-sm">Select Item</h5>
  </template>
  <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
          <div class="w-full overflow-auto">
            <table class="table table-hover">
                <thead class="bg-indigo-400 text-sm text-white">
                    <tr class="w-full flex">
                        <th class="p-tiny w-1/6">ID</th>
                        <th class="p-tiny w-1/3">Name</th>
                        <th class="p-tiny w-1/3">Stock Level</th>
                        <th class="p-tiny w-1/6">Action</th>
                    </tr>
                </thead>
                <tbody 
                    class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                    style="max-height:70vh;">
                    <tr class="w-full flex" v-for="(item,idx) in items" :key="idx">
                        <td class="p-tiny w-1/6">{{ item.itemID }}</td>
                        <td class="p-tiny w-1/3">{{ item.itemName }}</td>
                        <td class="p-tiny w-1/3">{{ item.stockLevel }}</td>
                        <td class="p-tiny w-1/6">
                            <button class="btn-sm text-xs btn-primary" 
                                title="Select Item" @click.prevent="setItem(item)">
                                    Select</button>
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>
      </div>
    
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs mr-4" @click="$emit(`closeModal`)">
        <i class="fa fa-times"></i> Cancel</button>
  </template>
</tail-modal>
</template>
